module.exports = __webpack_public_path__ + "static/media/50_B.1d2236e4.png";